import {TargetBlank} from '@wandb/weave/common/util/links';
import {Button} from '@wandb/weave/components';
import React, {useContext} from 'react';

import {SubscribeCheckoutModal} from '../../../pages/Billing/Checkout/SubscribeCheckoutModal';
import type {SubscribeProduct} from '../../../pages/Billing/Checkout/SubscribeForm';
import {TRIAL_END_PATH} from '../../../routes/onboarding/onboardingPaths';
import {
  StripeElementsComp,
  useAccountPrivileges,
} from '../../../util/accounts/pricing';
import * as urls from '../../../util/urls';
import {AccountSelectorContext} from '../../Search/SearchNav/AccountSelectorContextProvider';

export function ContactSalesCTA({shouldUnderline = false}) {
  return (
    <div className="my-[-16px] ml-auto flex items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="my-0 border-moon-750 bg-transparent text-wb-text-primary hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-wb-text-primary">
        <TargetBlank
          href={urls.contactSalesPricing()}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          Talk to sales
        </TargetBlank>
      </Button>
    </div>
  );
}

export function ContactSupportCTA({
  shouldUnderline = false,
  label = 'Talk to support',
}: {
  shouldUnderline?: boolean;
  label?: string;
}) {
  return (
    <div className="my-[-16px] ml-auto flex  items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="border-moon-750 bg-transparent text-wb-text-primary hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-wb-text-primary">
        <TargetBlank
          href={urls.contactSupportOther()}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          {label}
        </TargetBlank>
      </Button>
    </div>
  );
}

export function UpgradePlanCTA({
  shouldUnderline = false,
  label = 'Upgrade plan',
}: {
  shouldUnderline?: boolean;
  label?: string;
}) {
  return (
    <div className="my-[-16px] ml-auto flex items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="border-moon-750 bg-transparent text-wb-text-primary hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-wb-text-primary">
        <TargetBlank
          href={TRIAL_END_PATH}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          {label}
        </TargetBlank>
      </Button>
    </div>
  );
}

export function ActivateCTA({
  product = 'inference',
}: {
  product?: SubscribeProduct;
} = {}) {
  const [showUpgradeModel, setShowUpgradeModel] = React.useState(false);
  const [activationCompleted, setActivationCompleted] = React.useState(false);
  const {selectedAccount} = useContext(AccountSelectorContext);
  // we could pass this in from parent scope to avoid re-query but parent scope doesn't use privileges atm lol
  const {privileges} = useAccountPrivileges(selectedAccount);
  return (
    <>
      <div className="my-[-16px] ml-auto flex items-center gap-8">
        <Button
          variant="outline"
          size="large"
          onClick={() => setShowUpgradeModel(true)}
          className="border-moon-750 bg-transparent text-wb-text-primary hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-wb-text-primary">
          Activate pay-as-you-go
        </Button>
      </div>
      {showUpgradeModel && privileges && (
        <StripeElementsComp>
          <SubscribeCheckoutModal
            onTransactionCompleted={() => setActivationCompleted(true)}
            onClose={() => {
              setShowUpgradeModel(false);
              if (activationCompleted) {
                window.location.reload();
              }
            }}
            orgID={selectedAccount?.id ?? ''}
            primarySub={null /*pls work lol*/}
            privileges={privileges!}
            product={product}
          />
        </StripeElementsComp>
      )}
    </>
  );
}
